function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 10a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7zm10 0H7v7h9v-7zm6 7V9h1v8h.463l1.605-2.752.864.504-1.605 2.752a1 1 0 0 1-.864.496h-1.926a1 1 0 0 1-.864-.496l-1.605-2.752.864-.504L21.537 17H22zM9 15v-3h1v3H9zm2 0v-3h1v3h-1zm2 0v-3h1v3h-1zm13 7v1H6v-1h20z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerDown);
export default __webpack_public_path__ + "static/media/container-down.290b333cc999d02467f9bbe2b46cf546.svg";
export { ForwardRef as ReactComponent };